export interface Currency {
  code: string;
  label: string;
}

// All African currencies + major international currencies (USD, EUR, GBP)
export const CURRENCIES: Currency[] = [
  // International
  { code: "EUR", label: "EUR - Euro" },
  { code: "GBP", label: "GBP - British Pound Sterling" },
  { code: "USD", label: "USD - US Dollar" },
  // African currencies (alphabetical by code)
  { code: "AOA", label: "AOA - Angolan Kwanza" },
  { code: "BIF", label: "BIF - Burundian Franc" },
  { code: "BWP", label: "BWP - Botswana Pula" },
  { code: "CDF", label: "CDF - Congolese Franc" },
  { code: "CVE", label: "CVE - Cape Verdean Escudo" },
  { code: "DJF", label: "DJF - Djiboutian Franc" },
  { code: "DZD", label: "DZD - Algerian Dinar" },
  { code: "EGP", label: "EGP - Egyptian Pound" },
  { code: "ERN", label: "ERN - Eritrean Nakfa" },
  { code: "ETB", label: "ETB - Ethiopian Birr" },
  { code: "GHS", label: "GHS - Ghanaian Cedi" },
  { code: "GMD", label: "GMD - Gambian Dalasi" },
  { code: "GNF", label: "GNF - Guinean Franc" },
  { code: "KES", label: "KES - Kenyan Shilling" },
  { code: "KMF", label: "KMF - Comorian Franc" },
  { code: "LRD", label: "LRD - Liberian Dollar" },
  { code: "LSL", label: "LSL - Lesotho Loti" },
  { code: "LYD", label: "LYD - Libyan Dinar" },
  { code: "MAD", label: "MAD - Moroccan Dirham" },
  { code: "MGA", label: "MGA - Malagasy Ariary" },
  { code: "MRU", label: "MRU - Mauritanian Ouguiya" },
  { code: "MUR", label: "MUR - Mauritian Rupee" },
  { code: "MWK", label: "MWK - Malawian Kwacha" },
  { code: "MZN", label: "MZN - Mozambican Metical" },
  { code: "NAD", label: "NAD - Namibian Dollar" },
  { code: "NGN", label: "NGN - Nigerian Naira" },
  { code: "RWF", label: "RWF - Rwandan Franc" },
  { code: "SCR", label: "SCR - Seychellois Rupee" },
  { code: "SDG", label: "SDG - Sudanese Pound" },
  { code: "SLE", label: "SLE - Sierra Leonean Leone" },
  { code: "SOS", label: "SOS - Somali Shilling" },
  { code: "STN", label: "STN - São Tomé and Príncipe Dobra" },
  { code: "SZL", label: "SZL - Swazi Lilangeni" },
  { code: "TND", label: "TND - Tunisian Dinar" },
  { code: "TZS", label: "TZS - Tanzanian Shilling" },
  { code: "UGX", label: "UGX - Ugandan Shilling" },
  { code: "XAF", label: "XAF - Central African CFA Franc" },
  { code: "XOF", label: "XOF - West African CFA Franc" },
  { code: "ZAR", label: "ZAR - South African Rand" },
  { code: "ZMW", label: "ZMW - Zambian Kwacha" },
  { code: "ZWG", label: "ZWG - Zimbabwean Gold" },
];
